<template>
  <div class="box-cont">
    <div class="box">
      <div class="title">
        <el-page-header @back="goBack" ></el-page-header>
        <div class="btn" @click="addItem">
          添加试题
        </div>
      </div>
      <div v-if="listData.length!=0" class="cont" >
        <div class="row" v-for="item in listData" :key="item.id">
          <div style="height:100%">
            <div class="row-item1"><span style="
          font-family: SourceHanSansCN-Regular;
          font-size: 14px;
          font-weight: normal;
          letter-spacing: 0em;
          color: #333333;">{{item.index}}、{{item.questWord}} （<span v-if="item.questType==1">单选题</span><span v-if="item.questType==2">多选题</span><span v-if="item.questType==3">判断题</span>）</span></div>
          <div class="row-item2"><p v-for="child in item.optionList" :key="child.id">{{child.opOption}}、{{child.opWord}}</p></div>
          <div class="row-item3">答案是：{{item.answer}}</div>
          </div>
          <div class="btns">
            <div class="btn-t" @click="handleEdit(item)">修改</div>
            <div class="btn-b" @click="delExam(item)">删除</div>
          </div>
        </div>
      </div>
      <div v-else class="text">暂无数据</div>
      <el-pagination
      v-if="listData.length!=0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[ 20, 50, 100,200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import util from '../../../untils/util';
import myHttp from '../../../untils/port'
  export default {
    data() {
      return {
        pageNum: 1,
        pageSize:20,
        search:{
          storeId:''
        },
        groupId:'',
        groupType:'1',
        totalItems:0,
        listData:[]
      }
    },
    mounted(){
      this.groupId = util.session.get('groupId')
      this.search.storeId = this.$route.query.id
      this.getData()
    },
    methods:{
      //删除
    delExam(row){
      var that = this;
      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.appExamDel({
          id:row.id,
          storeId:row.storeId
        }).then(function(resp){
          if(resp.data.code=="200"){
              that.$message.success('题目删除成功');
              that.getData();
          }else{
              that.$message.error(resp.data.msg);
          }
        });
      }).catch(err => {})
    },
      //修改
    handleEdit(row){
      this.$router.push({path: "/topicOperation", query: {
        id: row.id,
        module:this.$route.query.module,
        storeType:this.$route.query.storeType
      }});
      
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getData()
    },
      //返回
        goBack(){
            if(this.$route.query.module=='exam'){
              this.$router.push({
                path:'examRun',
                query:{
                  type:3
                }
              })
            }else if(this.$route.query.module=='party'){
              if(this.$route.query.storeType=='2'){
                this.$router.push({
                  path:'/answerExercisesSetUp',
                  query:{
                    storeType:this.$route.query.storeType,
                    pageSize:this.$route.query.pageSize,
                    pageNum:this.$route.query.pageNum,
                    active:0
                  }
                })
              }else{
                this.$router.push({
                  path:'/answerExercisesSetUp',
                  query:{
                    storeType:this.$route.query.storeType,
                    pageSize:this.$route.query.pageSize,
                    pageNum:this.$route.query.pageNum,
                    active:1
                  }
                })
              }
            }
            
        },
      addItem(){
        let that = this
        this.$router.push({
          path:'/topicOperation',
          query:{
            tmid:that.$route.query.id,
            id:0,
            module:this.$route.query.module,
            storeType:this.$route.query.storeType,
          }
        })
      },
      // 获取数据
      getData() {
        var that = this;
        myHttp.getExamList({
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          storeId:this.search.storeId,
          // groupId:this.groupId,
          groupType:this.groupType
        }).then(function(resp){
          console.log(resp)
          if(resp.data.code=="200"){
            var list = resp.data.data.pageInfo.list||[];
            for(var i=0;i<list.length;i++){
              list[i].index = ((that.pageNum - 1) * that.pageSize)+(i+1);
            }
            that.listData = list;
            console.log(that.listData,'162')
            that.totalItems = resp.data.data.pageInfo.total||0
          }
        });
        // myHttp.getEntPerson(this.search).then(function(resp){
        //   if(resp.data.code=="200"){
        //       var list = resp.data.data.pageInfo||[];
        //       that.listData = list;
        //   }else{
        //     that.$message.error(resp.data.msg);
        //   }
        // },function(){});
      },
    }
  }
</script>

<style scoped>
.box-cont{
  width: 100%;
  height: 100%;
  background-color: #ECF0F5;
  padding: 12px 24px 10px 8px;
}
.box{
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  overflow: hidden;
}
.title{
  height: 6vh;
  border-bottom: 2px solid #D8D8D8;
  padding-right: 2%;
  padding-left: 2%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cont{
  height: 77vh;
  overflow: auto;
}
.btn{
  width: 80px;
height: 32px;
border-radius: 6px;
background: #FDFEFE;
box-sizing: border-box;
border: 1px solid #999999;
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
display: flex;
  justify-content: center;
  align-items: center;
}
.btn:hover{
  cursor: pointer;
  opacity: 0.7;
}
.text{
  margin-top: 10%;
}
.row{
  border-bottom: 1px solid #E4E7EE;
  padding-bottom: 8px;
  padding-left: 15px;
  padding-right: 28px;
  display: flex;
  justify-content: space-between;
}
.row-item1{
  padding-top: 8px;
  text-align: start;
  font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
word-break: break-all;
display: flex;
}
.row-item2{
  padding-top: 8px;
  padding-left: 29px;
  text-align: start;
  font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
word-break: break-all;
display: flex;
}
.row-item2>p{
  font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
margin-right: 34px;
}
.row-item3{
  padding-top: 8px;
  padding-left: 29px;
  text-align: start;
  font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
word-break: break-all;
}
.btn-t{
  margin-top: 12px;
  width: 50px;
height: 24px;
border-radius: 4px;
background: rgba(227, 233, 246, 0.05);
box-sizing: border-box;
border: 1px solid rgba(153, 153, 153, 0.8);
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #8EA3CE;
}
.btn-t:hover{
  cursor: pointer;
  opacity: 0.7;
}
.btn-b{
  margin-top: 10px;
  width: 50px;
height: 24px;
border-radius: 4px;
background: rgba(227, 233, 246, 0.05);
box-sizing: border-box;
border: 1px solid rgba(236, 15, 15, 0.8);
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #F57979;
box-sizing: border-box;
border: 1px solid rgba(236, 15, 15, 0.8);
}
.btn-b:hover{
  cursor: pointer;
  opacity: 0.7;
}
.el-pagination{
  border-radius: 0px 0px 6px 6px;
background: #FFFFFF;
box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}
</style>